import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  product: belongsTo('product', { inverse: null }),
  targets: hasMany('short-url-target', { inverse: 'shortUrl' }),
  utmMedium: belongsTo('category', { inverse: null }),
  utmSource: belongsTo('category', { inverse: null }),
});
